import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./App.css";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage.jsx";
import UploadPage from "./pages/UploadPage.jsx";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import RegisterForm from "./pages/RegisterForm.jsx";
import AuthPage from "./pages/AuthPage.jsx";
import Profile from "./pages/Profile.jsx";
import Upcoming from "./pages/Upcoming.jsx";
import RoutePage from "./pages/RoutePage.jsx";
import RotaDetaySayfasi from "./pages/RotaDetaySayfasi.jsx";
import YeniRotaOlustur from "./pages/YeniRotaOlusturucu.jsx";
import AnkaraPrototype from "./pages/AnkaraPrototype.jsx";
import MekanDetay from "./pages/MekanDetay.jsx";
import Dashboard from "./pages/admin/Dashboard.jsx";
import Users from "./pages/admin/Users.jsx";
import Places from "./pages/admin/Places.jsx";
import Predictions from "./pages/admin/Predictions.jsx";
import Narrations from "./pages/admin/Narrations.jsx";
import Comments from "./pages/admin/Comments.jsx";
import Messages from "./pages/admin/Messages.jsx";
import RouteManager from "./pages/admin/RouteManager.jsx";
import Application from "./pages/admin/Application.jsx";
import Blog from "./pages/admin/Blog.jsx";
import AdminLayout from "./components/AdminLayout.jsx";
import AdminLogin from "./pages/AdminLogin.jsx";
import Footer from "./components/Footer.jsx";
import FAQPage from "./pages/FAQPage.jsx";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage.jsx";
import TermsOfServicePage from "./pages/TermsOfServicePage.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";
import ReleaseNotesPage from "./pages/ReleaseNotesPage.jsx";
import PricingPage from "./pages/PricingPage.jsx";
import PricingPolicyPage from "./pages/PricingPolicyPage.jsx";
import BlogHomePage from "./pages/BlogHomePage.jsx";
import BlogPostPage from "./pages/BlogPostPage.jsx";
import VirtualTourPage from "./pages/VirtualTourPage.jsx";
import VRTour from "./pages/VRTour.jsx";
import AppsPage from "./pages/AppsPage.jsx";
import QuizPage from "./pages/QuizPage.jsx";
import QuizCard from "./pages/QuizCard.jsx";
import QuizAdd from "./pages/admin/QuizAdd.jsx";
import TeamPage from "./pages/TeamPage.jsx";
import TeamJoinPage from "./pages/TeamJoinPage.jsx";
import BadgeSystemPage from "./pages/BadgeSystemPage.jsx";
import CreditSystemPage from "./pages/CreditSystemPage.jsx";
import RankingPage from "./pages/RankingPage.jsx";
import TaskTracker from "./pages/TaskTracker";
import Report from "./pages/admin/Report.jsx";
import DirectoryPage from "./pages/DirectoryPage.jsx";
import CreditPage from "./pages/PaymentPage.jsx";
import SocialMedia from "./pages/SocialMedia.jsx";
import RegisterSuccess from "./pages/RegisterSuccess.jsx";
import FavoritePlaces from "./pages/FavoritePages.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import AIModuleRoadmap from "./pages/AIModuleRoadmap.jsx";
import AIHome from "./pages/AIHome.jsx";
import AIAssistant from "./pages/AIAssistant.jsx";
import SoundControl from "./components/SoundControl.jsx";
import EditorLayout from "./components/EditorLayout.jsx";
import EditorLogin from "./pages/editor/EditorLogin.jsx";
import EditorDashboard from "./pages/editor/EditorDashboard.jsx";
import CreateRoutePage from "./pages/editor/CreateRoutePage.jsx";
import Editor from "./pages/admin/Editor.jsx";
import WriteBlogPage from "./pages/editor/WriteBlogPage.jsx"
import Contents from "./pages/editor/Contents.jsx"
import Approval from "./pages/admin/AdminApproval.jsx"
import TokenSettings from "./pages/admin/TokenSettings.jsx"
import EditorBasvuruFormu from "./pages/EditorBasvuruFormu.jsx";
import ResetPasswordPage from "./pages/ResetPasswordPage.jsx";
import PlacesId from "./pages/admin/PlacesId.jsx";
import ReportsPage from "./pages/admin/Reports.jsx";
import HelpPage from "./pages/HelpPage.jsx";
import AdminUserPackages from "./pages/admin/Packages.jsx";
import CheckoutPage from './pages/CheckoutPage';
import AdminRoute from "./components/AdminRoute.jsx";


// Navbar ve Footer kontrolü için yardımcı bileşen
// useLocation sadece Router içinde çalışır, bu yüzden bu bileşeni oluşturduk.
function AppLayout({ children, isLoggedIn, onLogout }) {
  const location = useLocation();

  // 1. Navbar'ın GİZLENMESİ gereken sayfalar
  const hideNavbarRoutes = ["/ai-assistant"];
  const shouldShowNavbar = !hideNavbarRoutes.includes(location.pathname);

  // 2. Footer'ın GİZLENMESİ gereken sayfalar (Senin kodundaki mantık)
  const hideFooterRoutes = ["/ai-assistant"];
  const shouldShowFooter = !hideFooterRoutes.includes(location.pathname);

  return (
    <>
      {/* Navbar sadece izin verilen sayfalarda görünür */}
      {shouldShowNavbar && <Navbar isLoggedIn={isLoggedIn} onLogout={onLogout} />}

      {/* Navbar gizlendiğinde 'pt-16' padding'ini de kaldırıyoruz ki 
         sayfa üstten boşluklu başlamasın.
      */}
      <div className={`${shouldShowNavbar ? "pt-16" : ""} bg-gray-900`}>
        {children}
      </div>

      {shouldShowFooter && <Footer />}
    </>
  );
}

function App() {
  const [placeData, setPlaceData] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return !!localStorage.getItem("token");
  });

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };
  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem("token");
  };

  return (
    <GoogleOAuthProvider clientId="867446045772-1l021hti8u387aq70gh3d36i37e9sqfe.apps.googleusercontent.com">
      <Router>
        <ScrollToTop />
        
        {/* Tüm sayfa yapısını AppLayout içine aldık */}
        <AppLayout isLoggedIn={isLoggedIn} onLogout={handleLogout}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/upload"
              element={
                localStorage.getItem("token") ? (
                  <UploadPage />
                ) : (
                  <AuthPage onLoginSuccess={handleLoginSuccess} />
                )
              }
              className="bg-white p-6 rounded-xl shadow-md w-full max-w-xl transition-all align-middle text-center"
            />
            <Route
              path="/AI"
              element={
                localStorage.getItem("token") ? (
                  <AIHome />
                ) : (
                  <AuthPage onLoginSuccess={handleLoginSuccess} />
                )
              }
              className="bg-white p-6 rounded-xl shadow-md w-full max-w-xl transition-all align-middle text-center"
            />
            <Route
              path="/ai-assistant"
              element={
                localStorage.getItem("token") ? (
                  <AIAssistant />
                ) : (
                  <AuthPage onLoginSuccess={handleLoginSuccess} />
                )
              }
              className="bg-white p-6 rounded-xl shadow-md w-full max-w-xl transition-all align-middle text-center"
            />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/register" element={<RegisterForm />} />
            <Route
              path="/login"
              element={<AuthPage onLoginSuccess={handleLoginSuccess} />}
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute allowGuests={false}>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route path="/upcoming" element={<Upcoming />} />
            <Route path="/route" element={<RoutePage />} />
            <Route
              path="/rotalar/:rotaId"
              element={
                <ProtectedRoute allowGuests={false}>
                  <RotaDetaySayfasi />
                </ProtectedRoute>
              }
            />
            <Route
              path="/new-route"
              element={
                <ProtectedRoute allowGuests={false}>
                  <YeniRotaOlustur />
                </ProtectedRoute>
              }
            />
            <Route
              path="/favorite-mekan"
              element={
                <ProtectedRoute allowGuests={false}>
                  <FavoritePlaces />
                </ProtectedRoute>
              }
            />
            <Route path="/mekan" element={<AnkaraPrototype />} />
            <Route path="/mekan/:mekanId" element={<MekanDetay />} />
            <Route path="/sss" element={<FAQPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/service" element={<TermsOfServicePage />} />
            <Route path="/release-notes" element={<ReleaseNotesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/pricing-policy" element={<PricingPolicyPage />} />
            <Route path="/blog" element={<BlogHomePage />} />
            <Route path="/blog/:blogId" element={<BlogPostPage />} />
            <Route path="/virtual-tour" element={<VirtualTourPage />} />
            <Route path="/virtual-tour/:tourSlug" element={<VRTour />} />
            <Route path="/apps-page" element={<AppsPage />} />
            <Route path="/quiz" element={<QuizCard />} />
            <Route path="/quiz/:quizId" element={<QuizPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/team-join" element={<TeamJoinPage />} />
            <Route path="/badge-system" element={<BadgeSystemPage />} />
            <Route path="/credit-system" element={<CreditSystemPage />} />
            <Route path="/ranking" element={<RankingPage />} />
            <Route path="/task-tracker" element={<TaskTracker />} />
            <Route path="/rehber" element={<DirectoryPage />} />
            <Route path="/payment" element={<CreditPage />} />
            <Route path="/social-media" element={<SocialMedia />} />
            <Route path="/register-success" element={<RegisterSuccess />} />
            <Route path="/ai-roadmap" element={<AIModuleRoadmap />} />
            <Route path="/editor-basvuru-formu" element={<EditorBasvuruFormu />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/checkout/:planId" element={<CheckoutPage />} />

            <Route path="/admin-login" element={<AdminLogin />} />
            {/* ADMIN ROUTES */}
            <Route path="/admin" element={<AdminRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="users" element={<Users />} />
                <Route path="places" element={<Places />} />
                <Route path="places-ai" element={<PlacesId />} />
                <Route path="predictions" element={<Predictions />} />
                <Route path="narrations" element={<Narrations />} />
                <Route path="comments" element={<Comments />} />
                <Route path="messages" element={<Messages />} />
                <Route path="routesAdmin" element={<RouteManager />} />
                <Route path="quizAdd" element={<QuizAdd />} />
                <Route path="application" element={<Application />} />
                <Route path="report" element={<Report />} />
                <Route path="blog" element={<Blog />} />
                <Route path="editor" element={<Editor />} />
                <Route path="approval" element={<Approval />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="token" element={<TokenSettings />} />
                <Route path="user-packages" element={<AdminUserPackages />} />
              </Route>
            </Route>

            <Route path="editor-login" element={<EditorLogin />} />
            <Route path="/editor" element={<EditorLayout />}>
              <Route path="dashboard" element={<EditorDashboard />} />
              <Route path="create-route" element={<CreateRoutePage />} />
              <Route path="write-blog" element={<WriteBlogPage />} />
              <Route path="my-contents" element={<Contents />} />
            </Route>

          </Routes>
        </AppLayout>
      </Router>
      <SoundControl />
    </GoogleOAuthProvider>
  );
}

export default App;